import { render, staticRenderFns } from "./HeaderWidgetComponent.vue?vue&type=template&id=ebcd3b9e&"
import script from "./HeaderWidgetComponent.vue?vue&type=script&lang=js&"
export * from "./HeaderWidgetComponent.vue?vue&type=script&lang=js&"
import style0 from "./HeaderWidgetComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports